import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-vorlagen-liste-admin';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentVorlagenListeAdminEffects {

    IncidentVorlagenListeAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_VORLAGEN_LISTE_ADMIN),
        mergeMap((x: ac.GetIncidentVorlagenListeAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentVorlagenListeAdmin().pipe(
                map((result: any) => {
                    return new ac.GetIncidentVorlagenListeAdminErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentVorlagenListeAdminFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentVorlageQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentVorlageQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentVorlageQueryService);
        }
        return this.service;
    }
}
